import { Button } from '@vrplatform/components';
import { useBilling } from '@vrplatform/data';
import { useDisclosure } from '@mantine/hooks';
import { AddAccountModal } from './AddAccountModal';

export const AddAccountButton = () => {
  const [opened, handlers] = useDisclosure(false);

  const { isReadOnly } = useBilling();

  if (isReadOnly) return null;

  return (
    <>
      <Button variant="primary" leftIcon={'PlusIcon'} onClick={handlers.open}>
        Add account
      </Button>

      <AddAccountModal opened={opened} closeModal={handlers.close} />
    </>
  );
};
